module.exports = __webpack_public_path__ + "static/media/auv_badge.d0b27ed0.png";